import React, { Component } from "react";
import { Galleria } from "primereact/galleria";
import { withTranslation } from "react-i18next";
import CommonFunctions from "../Utils/CommonFunctions";
import { Link, Navigate, useNavigate } from "react-router-dom";
import FooterMobile from "./FooterMobile";
import ModelBuilder from "./Modal/ModelBuilder";
class HeaderMobile extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    let urlParams = new URLSearchParams(window.location.search);
    let myParam = urlParams.get("mobile");
    this.themesource =
      this.props.ThemePage == undefined
        ? ""
        : this.props.ThemePage.toLowerCase();
    this.state = {
      language: CommonFunctions.getSelectedLanguage(), // get the selected language
      SubThemeInfo: this.props.Images,
      activeIndex: 0,
      Header: myParam == "yes" ? false : true,
    };

    this.setState({ activeIndex: 0 });
  }

  // for hamburger menu expand collapse
  menuOnClick(e) {
    let sidebarPanel = document.getElementById("sidebarPanel");
    let body = document.getElementsByTagName("body");
    let modalBackdrop = document.getElementById("modalBackdrop");
    sidebarPanel.classList.toggle("show");
    if (sidebarPanel.style.display === "block") {
      sidebarPanel.style.display = "none";
      modalBackdrop.style.display = "none";
      body[0].style.overflow = "auto";
    } else {
      sidebarPanel.style.display = "block";
      modalBackdrop.style.display = "block";
      body[0].style.display = "hidden";
    }
  }
  //For language selection
  languagesel(e) {
    var lng = e.currentTarget.innerText;
    if (lng == "ENG") {
      sessionStorage.setItem("language", "en");
      this.setState({ language: "en" });
    } else {
      sessionStorage.setItem("language", "ar");
      this.setState({ language: "ar" });
    }
    window.location.reload();
  }

  Themehelight(res, that, e) {
    let tablinks = document.getElementsByClassName("headitem");
    for (var i = 0; i < tablinks.length; i++) {
      if (that.state.activeIndex != res) {
        tablinks[i].className = tablinks[i].className.replace(" it_active", "");
      }
    }
    that.setState({ activeIndex: res });
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeindex != prevProps.activeindex) {
      let urlParams = new URLSearchParams(window.location.search);
      let myParam = urlParams.get("mobile");
      if (myParam == "yes") {
        this.setState({ Header: false });
      }
      this.setState({ activeIndex: this.props.activeindex });
    }
  }
  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search);
    let myParam = urlParams.get("mobile");
    if (myParam == "yes") {
      this.setState({ Header: false });
    } else {
      window.HeadrRoom();
    }

    let theme = CommonFunctions.renderThemeName();
    if (theme == null) return;
    if (theme.toLowerCase() == "energy") {
      window.loadHeaderCarasoulmobile(
        this.state.language == "en" ? false : true,
        2,
        this.props.activeindex
      );
    } else {
      window.loadHeaderCarasoulmobile(
        this.state.language == "en" ? false : true,
        3,
        this.props.activeindex
      );
    }
    if (this.state.language == "ar") {
      this.setState({ activeIndex: this.props.activeindex });
    } else {
      this.setState({ activeIndex: this.props.activeindex });
    }
  }

  render() {
    const { t } = this.props;
    var SubThemesInfo = this.state.SubThemeInfo;
    var that = this;
    var ThemesCorousel = [];

    var ThemesInfo = this.props.ThemesInfo;
    var ThemesItems = [];
    for (var i = 0; i < ThemesInfo.length; i++) {
      ThemesItems.push(
        <li>
          {" "}
          <Link to={ThemesInfo[i].href} className="item">
            <div className="icon-box">
              {" "}
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/" +
                  ThemesInfo[i].mobileImageUrl
                }
                alt=""
                className="img-menu"
              />{" "}
            </div>
            <div className=""> {ThemesInfo[i].ThemeTitle} </div>
          </Link>{" "}
        </li>
      );
    }

    if (SubThemesInfo != "") {
      var imageurl = this.props.ThemesInfo.find(
        (x) => x.ThemeName == this.props.ThemeName
      ).mobileImageUrl;
      for (var i = 0; i < SubThemesInfo.length; i++) {
        ThemesCorousel.push(
          <div
            className={
              this.state.activeIndex == i
                ? "item headitem mt-4 it_active"
                : "item headitem mt-4"
            }
          >
            <Link
              to={SubThemesInfo[i].href}
              className="sidebar-anchor menuclose"
              id={i}
              onClick={that.Themehelight.bind(this, i, that)}
            >
              <div className="Health storylineCircle">
                <img
                  src={process.env.REACT_APP_BASE_URL + "/" + imageurl}
                  alt=""
                  className="imaged"
                />
              </div>
              <h5 className="subtheme_title">{SubThemesInfo[i].title}</h5>
            </Link>
          </div>
        );
      }
    }

    return (
      <div>
        <header dir={t("direction")}>
          {/*  <!-- App Header --> */}
          {this.state.Header && (
            <div id="header" className="appHeader  shadow">
              <div className="left menuclose">
                {" "}
                <a
                  className="headerButton menuclose"
                  data-toggle="modal"
                  data-target="#sidebarPanel"
                >
                  {" "}
                  <i
                    onClick={this.menuOnClick.bind(this)}
                    className="menuclose fa-solid fa-bars fa-fw ft_1"
                  ></i>{" "}
                </a>{" "}
              </div>
              <div className="pageTitle">
                {" "}
                <img
                  src={
                    process.env.REACT_APP_BASE_URL + "/images/FGIC_Logo2.svg"
                  }
                  alt=""
                  className="mob_logo"
                />{" "}
              </div>
              <div className="right">
                <div className="languagebar1">
                  {" "}
                  <a
                    className="act"
                    style={
                      this.state.language == "en"
                        ? { color: "#a14926", background: "#f8c5b2" }
                        : { color: "#3f3b3a", background: "#e4e4e4" }
                    }
                    onClick={this.languagesel.bind(this)}
                  >
                    ENG
                  </a>{" "}
                  <a
                    style={
                      this.state.language == "ar"
                        ? { color: "#a14926", background: "#f8c5b2" }
                        : { color: "#3f3b3a", background: "#e4e4e4" }
                    }
                    className="  arab_br"
                    onClick={this.languagesel.bind(this)}
                  >
                    العربية
                  </a>{" "}
                </div>
              </div>
            </div>
          )}
          {/* <!-- * Banner --> */}
          <div className="section full mt-1 mb-3 bg-white shadow-sm" dir="ltr">
            {/* <!-- carousel --> */}
            {ThemesCorousel.length == 0 && (
              <div className="con_div">
                <h3 className="text-uppercase">{this.props.ThemeName} </h3>
              </div>
            )}
            {ThemesCorousel.length !== 0 && (
              <div className="container-fluid">
                <div
                  id="MobileHeaderCorousel"
                  className={
                    "carousel-full-story owl-carousel owl-theme sty_hd mobcarousel_" +
                    ThemesCorousel.length
                  }
                >
                  {ThemesCorousel}
                </div>
              </div>
            )}
            {/* <!-- * carousel -->  */}

            {/* <!-- App Sidebar --> */}
            <div
              className="modal  fade panelbox panelbox-left"
              id="sidebarPanel"
              tabindex="-1"
              role="dialog"
            >
              <div className="modal-dialog menuclose" role="document">
                <div className="modal-content menuclose">
                  <div className="modal-body menuclose p-0">
                    {/* <!-- profile box --> */}
                    <div className="profileBox menuclose">
                      <div className="image-wrapper menuclose">
                        {" "}
                        <Link to="/Index">
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/images/FGIC_Logo.svg"
                            }
                            alt="image"
                            className="mob_logo_wh menuclose"
                          />
                        </Link>{" "}
                      </div>
                      <a
                        className="close-sidebar-button"
                        onClick={this.menuOnClick.bind(this)}
                      >
                        {" "}
                        <i className="fa-solid fa-xmark "></i>{" "}
                      </a>{" "}
                    </div>
                    {/* <!-- * profile box --> */}
                    <ul className="listview flush transparent no-line image-listview ">
                      {ThemesItems}
                      <li className="sidebar-item act menuclose">
                        <ModelBuilder />
                      </li>
                    </ul>
                    <ul className="nav-social menuclose">
                      <li className="menuclose">
                        <a
                          className="menuclose"
                          href="https://twitter.com/fgic_uae"
                          target="_blank"
                        >
                          <i className="fab fa-twitter menuclose"></i>
                        </a>
                      </li>
                      <li className="menuclose">
                        <a
                          className="menuclose"
                          href="https://www.instagram.com/fgic_uae"
                          target="_blank"
                        >
                          <i className="fab fa-instagram menuclose"></i>
                        </a>
                      </li>
                      <li className="menuclose">
                        <a
                          className="menuclose"
                          href="https://wa.me/971547240288"
                          target="_blank"
                        >
                          <i className="fab fa-whatsapp menuclose"></i>
                        </a>
                      </li>
                      {/*  <li className="menuclose">
                      <a className="menuclose" href="#">
                        <i className="fab fa-linkedin-in menuclose"></i>
                      </a>
                    </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- * App Sidebar -->  */}
          </div>
        </header>
      </div>
    );
  }
}
function WithNavigate(props) {
  let navigate = useNavigate();
  return <HeaderMobile {...props} navigate={navigate} />;
}
export default withTranslation()(WithNavigate);
